import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AxisUtilsService {
  public isResizing: any = false;

  public ACTIONS = {
    WINDOW_RESIZE: new BehaviorSubject<any>(false),
  };

  constructor() {
    // On Window Resize (only 1 event bind)
    fromEvent(window, 'resize')
      .pipe(debounceTime(50))
      .subscribe((e) => {
        if (this.isResizing) {
          clearTimeout(this.isResizing);
        }
        this.isResizing = setTimeout(() => {
          this.sendAction('WINDOW_RESIZE', e);
        }, 50);
      });
  }

  sendAction(action, payload) {
    if (action) {
      this.ACTIONS[action].next({ action, payload });
    }
  }
}
